import script from "./CollectionMethGeneration.vue?vue&type=script&setup=true&lang=js"
export * from "./CollectionMethGeneration.vue?vue&type=script&setup=true&lang=js"

import "./CollectionMethGeneration.vue?vue&type=style&index=0&id=78599d0f&lang=scss"

const __exports__ = script;

export default __exports__